var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKakao(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0004 17.9259C18.5255 17.9259 23.8152 13.9131 23.8152 8.96296C23.8152 4.01286 18.5255 0 12.0004 0C5.47522 0 0.185547 4.01286 0.185547 8.96296C0.185547 11.9364 2.09415 14.5717 5.03267 16.2021L4.25962 22L10.3169 17.8356C10.8667 17.8951 11.4288 17.9259 12.0004 17.9259Z",
    fill: "#3B1D1D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKakao);
export default __webpack_public_path__ + "static/media/kakao.b921d7258c67d946782de6382e392234.svg";
export { ForwardRef as ReactComponent };